/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'system-about-card';
const prefix = `${moduleName}.${componentName}`;

export const aboutHeader = `${prefix}.aboutHeader`;

export const ENGLISH = {
    [aboutHeader]: 'About',
};
